export default "__VITE_ASSET__f1d18082__"